import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA } from '../api/gesttor'
import { cadastrarTarefasPayload, paramsListaTarefas, atualizartarefasPayload, anexarDocumentoPayload, cadastrarComentarioPayload } from '../../interfaces/tasks'


// SERVICES PARA O CRUD DE TAREFAS

export function novaTarefa (payload: cadastrarTarefasPayload) {
    return BASEURLGESTTOR.post('/tarefas', payload)
} 

export function listarTarefas (params: paramsListaTarefas) {
    return BASEURLGESTTOR.get (`/tarefas?pagina=${params.pagina}&titulo=${params.titulo}&descricao=${params.descricao}&cliente=${params.cliente}&dataInicio=${params.dataInicio}&dataTermino=${params.dataTermino}&minhasSolicitacoes=${params.minhasSolicitacoes}&tarefasEscritorio=${params.tarefasEscritorio}&tarefasAutomaticas=${params.tarefasAutomaticas}&situacao=${params.situacao}&responsavel=${params.responsavel}&idUsuarioAprovador=${params.idUsuarioAprovador || ""}`)
}


export function atualizarTarefa (payload: atualizartarefasPayload) {
    return BASEURLGESTTOR.patch(`/tarefas`, payload)
}

export function deletarTarefa (idTarefa: string) {
    return BASEURLGESTTOR.delete(`/tarefas?idTarefa=${idTarefa}`)
}

// SERVICES PARA O CRUD DE ANEXOS

export function anexarArquivo (idTarefa: string, payload: anexarDocumentoPayload) {
    return BASEURLGESTTORFORMDATA.post(`/tarefas/anexos?idTarefa=${idTarefa}`, payload)
}

export function buscarAnexos (idTarefa: string) {
    return BASEURLGESTTOR.get(`/tarefas/anexos?idTarefa=${idTarefa}`)
}

export function deletarAnexo (idAnexo: string) {
    return BASEURLGESTTOR.delete(`/tarefas/anexos?idAnexo=${idAnexo}`)
}

// ROTAS PARA O CRUD DE COMENTÁRIOS

export function postarComentario (idTarefa: string, payload: cadastrarComentarioPayload) {
    return BASEURLGESTTOR.post(`/tarefas/comentarios?idTarefa=${idTarefa}`, payload)
}

export function listarComentarios (idTarefa: string) {
    return BASEURLGESTTOR.get(`/tarefas/comentarios?idTarefa=${idTarefa}`)
}

